module.exports = __webpack_public_path__ + "img/0b9f93f.png";